import { atom } from 'recoil';

import type { WalletInfo } from 'src/types/wallet';

export const ExtensionDefault: WalletInfo = {
  walletType: undefined,
  name: '',
  description: '',
  isInstalled: false,
};

export const ExtensionState = atom<WalletInfo>({
  key: 'extensionState',
  default: ExtensionDefault,
});
